export const VIEWING_ROOM_CACHE_KEY = "viewing-room";
export const VIEWING_ROOM_CACHE_KEY_INFINITE = "viewing-room-infinite";
